import { GroupIds, MOCK_TEST_GROUP_IDS } from "@/shared/group-configs/groups";
import { NIMBUS_GPT_LIVE_V3_ADMISSIONS } from "@/shared/group-configs/nimbus-voice-sites";
import type { GptLiveV3LineAdmission } from "@/shared/voice-runtime";

// Each customer owns its line admission beside its existing voice configuration.
const ADMISSIONS: readonly GptLiveV3LineAdmission[] = [...NIMBUS_GPT_LIVE_V3_ADMISSIONS];

export function findGptLiveV3LineAdmission(groupId: string, calledNumber: string): GptLiveV3LineAdmission | null {
  return ADMISSIONS.find((line) => line.groupId === groupId && line.calledNumber === calledNumber) ?? null;
}

/** Production admission never authorizes synthetic fixture execution. */
export function isGptLiveV3IntegrationGroup(groupId: string | undefined): groupId is GroupIds {
  return ADMISSIONS.some(
    (line) => line.groupId === groupId && !line.allowProduction && MOCK_TEST_GROUP_IDS.includes(line.groupId)
  );
}

export function isGptLiveV3IntegrationCall(groupId: string, calledNumber: string): boolean {
  const admission = findGptLiveV3LineAdmission(groupId, calledNumber);

  return admission !== null && !admission.allowProduction && isGptLiveV3IntegrationGroup(groupId);
}
